import { useState, useEffect, useCallback } from 'react'

type WatermarkPosition = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'

export const useWatermarkPosition = (isPlaying: boolean) => {
  const [position, setPosition] = useState<WatermarkPosition>('topLeft')

  const getRandomPosition = useCallback((): WatermarkPosition => {
    const positions: WatermarkPosition[] = [
      'topLeft',
      'topRight',
      'bottomLeft',
      'bottomRight',
    ]
    const randomIndex = Math.floor(Math.random() * positions.length)
    return positions[randomIndex]
  }, [])

  useEffect(() => {
    let intervalId: NodeJS.Timeout

    if (isPlaying) {
      intervalId = setInterval(() => {
        setPosition(getRandomPosition())
      }, 60000) // 1 minuto em milissegundos
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [isPlaying, getRandomPosition])

  return position
}
